<template>
    <div class="staff-container container-1200">
        <PageTitle :title="'Executive Team'"></PageTitle>
        <div style="display: flex;justify-content: center;">
            <el-card class="staff-card" shadow="hover" style="margin-bottom: 20px;">
                <div class="staff-avatar">
                    <img src="../../../assets/images/staff/kristine.jpg" />
                </div>

                <div class="staff-info">
                    <strong class="staff-name">Kristine Guo</strong>
                    <div class="staff-reg">Managing Director</div>
                    <a :href="'mailto:kristineguo@contrimetric.com'"
                        class="staff-email">kristineguo@contrimetric.com</a>
                </div>
            </el-card>
        </div>
        <div class="staff-list">
            <el-card v-for="(staff, index) in staffList" :key="index" class="staff-card" shadow="hover">
                <div class="staff-avatar">
                    <img :src="staff.image" :class="staff.cv ? 'staff_imagehov' : ''" @click="goToBlank(staff.cv)"/>
                </div>

                <div class="staff-info">
                    <strong class="staff-name">{{ staff.name }}</strong>
                    <div class="staff-reg">{{ staff.title }}</div>
                    <div class="staff-region" v-if="staff.region">-{{ staff.region }}</div>
                    <a :href="'mailto:' + staff.email" class="staff-email">{{ staff.email }}</a>
                    <div v-if="staff.phone" class="staff-phone">{{ staff.phone }}</div>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
import PageTitle from "@/components/pageTitle/index.vue"

export default {
    name: "StaffList",
    components: {
        PageTitle
    },
    data() {
        return {
            staffList: [
            {
                    name: "Kaku",
                    title: "Regional Manager",
                    region: "Japan",
                    email: "kakuss@Contrimetric.com",
                    image: require("@/assets/images/staff/Kaku.png"),
                },
                {
                    name: "Carol Song",
                    title: "Regional Manager",
                    region: "Australia",
                    email: "carolsong@contrimetric.com",
                    image: require("@/assets/images/staff/song.png"),
                },
                {
                    name: "Bo",
                    title: "Regional Manager",
                    region: "UK",
                    email: "bo@contrimetric.com",
                    image: require("@/assets/images/staff/bo.png"),
                },
                {
                    name: "Shaun Zhao",
                    title: "Regional Manager",
                    region: "China",
                    email: "shaun@contrimetric.com",
                    phone: "",
                    image: require("@/assets/images/staff/shaun.png"),
                },
                {
                    name: "Sherry Liu",
                    title: "Regional Manager",
                    region: "China",
                    email: "SherryLiu@contrimetric.com",
                    image: require("@/assets/images/staff/sherry.png"),
                },
                {
                    name: "Kaelin Liu",
                    title: "Regional Manager",
                    region: "China",
                    email: "kaelin@contrimetric.com",
                    image: require("@/assets/images/staff/Kaelin.jpg"),
                },
            ]
        };
    },
    methods: {
        goToBlank(url) {
            if (url) {
                window.open(url, "_blank");
            }
        }
    }
};
</script>

<style scoped lang="scss">
.staff-container {
    padding: 20px;
}

.staff-list {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
}

.staff-card {
    width: calc(33% - 32px);
    padding: 10px;
    border-radius: 10px;
    min-height: 210px;
}

.staff-avatar {
    min-height: 210px;
    width: 45%;

    img {
        width: 150px;
        height: 210px;
        border-radius: 10px;
        object-fit: cover;
    }

    .staff_imagehov {
        &:hover {
            cursor: pointer;
        }
    }
}

.staff-phone {
    padding: 4px 0;
}

.staff-info {
    flex: 1;
    margin-top: 10px;
    font-size: 14px;
    word-break: break-word;
    line-height: 24px;
}

.staff-name {
    font-size: 18px;
}

.staff-reg {
    font-size: 16px;
    color: #333;
}

.staff-region {
    color: #999;
    margin: 4px 0;
}



.staff-email,
.staff-region a {
    color: #333;
    text-decoration: underline;

}

</style>
<style scoped lang="scss">
::v-deep .el-card__body {
    display: flex;
    align-items: center;
    padding: 0;
    gap: 10px;
}
</style>

<style scoped lang="scss">
@media screen and (max-width: 1024px) {
    .staff-card {
        width: 46%;
        min-height: unset !important;
    }

    .staff-avatar {
        // width: 30%;
        min-height: unset !important;
    }
}

/* 手机端竖屏 */
@media screen and (max-width: 768px) {
    .staff-card {
        width: 100%;
    }

    .staff-avatar {
        width: 35%;

        img {
            width: 120px;
            height: 150px;
        }
    }
}
</style>